import { render, staticRenderFns } from "./InvoiceCard.vue?vue&type=template&id=1f532feb&scoped=true"
import script from "./InvoiceCard.vue?vue&type=script&lang=js"
export * from "./InvoiceCard.vue?vue&type=script&lang=js"
import style0 from "./InvoiceCard.vue?vue&type=style&index=0&id=1f532feb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f532feb",
  null
  
)

export default component.exports